/**
 * AuthProvider - Syncs Firebase Auth state with Zustand store
 */

import { useEffect } from 'react'
import { useAuthStore } from '@/store/auth'
import { authService } from '@/services/firebase.service'

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { setUser, setLoading, logout } = useAuthStore()

  useEffect(() => {
    // Listen to Firebase Auth state changes
    const unsubscribe = authService.onAuthStateChange(async (firebaseUser) => {
      if (firebaseUser) {
        // User is signed in - get profile from Firestore
        try {
          const userProfile = await authService.getUserProfile(firebaseUser.uid)

          setUser({
            id: firebaseUser.uid, // Always use Firebase Auth UID
            email: firebaseUser.email || '',
            name: userProfile?.name || firebaseUser.displayName || 'Utente',
            avatar: firebaseUser.photoURL || userProfile?.avatar,
            plan: userProfile?.plan || 'free',
            minutesUsed: userProfile?.minutesUsed || 0,
            minutesLimit: userProfile?.minutesLimit || 60,
            voiceIdsUsed: userProfile?.voiceIdsUsed || 0,
            voiceIdsLimit: userProfile?.voiceIdsLimit || 3,
            createdAt: userProfile?.createdAt || new Date().toISOString(),
          })
        } catch (error) {
          console.error('Error fetching user profile:', error)
          // Set basic user info from Firebase Auth
          setUser({
            id: firebaseUser.uid,
            email: firebaseUser.email || '',
            name: firebaseUser.displayName || 'Utente',
            avatar: firebaseUser.photoURL || undefined,
            plan: 'free',
            minutesUsed: 0,
            minutesLimit: 60,
            voiceIdsUsed: 0,
            voiceIdsLimit: 3,
            createdAt: new Date().toISOString(),
          })
        }
      } else {
        // User is signed out
        logout()
      }
      setLoading(false)
    })

    return () => unsubscribe()
  }, [setUser, setLoading, logout])

  return <>{children}</>
}
